import script from "./goTop.vue?vue&type=script&setup=true&lang=js"
export * from "./goTop.vue?vue&type=script&setup=true&lang=js"

import "./goTop.vue?vue&type=style&index=0&id=d4cd71fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4cd71fa"]])

export default __exports__